export default __webpack_public_path__ + "static/media/bursaries_m@3x.1dac3428.png";